import React from 'react';
import { cn } from '../../lib/utils';

type AlertVariant = 'error' | 'warning' | 'info' | 'success';

interface AlertBannerProps {
  variant?: AlertVariant;
  children: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
}

const variantClasses: Record<AlertVariant, string> = {
  error: 'bg-critical-100 border-stone-200 text-critical-700',
  warning: 'bg-caution-100 border-stone-200 text-caution-700',
  info: 'bg-navy-100 border-stone-200 text-navy-700',
  success: 'bg-positive-100 border-stone-200 text-positive-700',
};

const defaultIcons: Record<AlertVariant, React.ReactNode> = {
  error: (
    <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.25} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  warning: (
    <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.25} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
    </svg>
  ),
  info: (
    <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.25} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  success: (
    <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.25} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
};

const AlertBanner: React.FC<AlertBannerProps> = ({
  variant = 'error',
  children,
  className,
  icon,
}) => {
  return (
    <div className={cn('flex items-start gap-3 p-3 border rounded-lg text-sm', variantClasses[variant], className)}>
      {icon || defaultIcons[variant]}
      <div className="flex-1">{children}</div>
    </div>
  );
};

export default AlertBanner;
